import React from "react";
import LaunchingSoon from "./LaunchingSoon";


const Projects = () => {
  return (
    <section id="projects" className="section">
      <h2>Products</h2>
      <p className="section-subtitle">
        {/* A sample of products and internal tools delivered by Stacksys. */}
      </p>

      <LaunchingSoon />
    </section>
  );
};

export default Projects;
